import React, { useState } from "react";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import EmployeeDetailsPage from "pages/users/drivers/employee/employeeDetails";
import { useTranslation } from "react-i18next";

const EmployeeTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  handleDeleteRequest,
  followers,
  followings,
  cities,
  countries,
  can_create,
  formikValues,
  options,
}) => {
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const { t } = useTranslation();
  const [supportedLang] = useState("en");
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          table={{
            list: data,
            listTitle: t("employee_drivers.list_title"),
            createBtnTitle: can_create && t("employee_drivers.new"),
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: t("employee_drivers.col_id") },
              {
                accessor: "name",
                Header: t("employee_drivers.col_name"),
                sort: true,
              },
              {
                accessor: "phone_number",
                Header: t("employee_drivers.col_phone"),
                sort: true,
              },
              {
                accessor: "state",
                Header: t("employee_drivers.col_availability"),
              },
              {
                accessor: "profile_status",
                Header: t("employee_drivers.col_status"),
              },
              {
                accessor: "Actions",
                Header: t("employee_drivers.col_actions"),
              },
            ],
            isSearch: false,
            searchInputPlaceholder: t("employee_drivers.search_placeholder"),
            isChecked: false,
            total_count: count,
            setFilterObj,
            className: "main-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList, //if you want to add custom actions list
            headerChildren,
            details,
            openDeleteModal,
            // setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            initialValues: !id ? {} : initialValues(details, supportedLang),
            structure: () => structure({ cities, countries, options }),
            validationSchema: (_) => validationSchema(formikValues, id),
            deleteFun: deleteFun,
            title: id ? t("employee_drivers.edit") : t("employee_drivers.new"),
            submitTitle: id
              ? t("employee_drivers.btn_update")
              : t("employee_drivers.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          DetailsComponent={
            <EmployeeDetailsPage details={details} actionsList={actionsList} />
          } //to send details component diff from the default
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default EmployeeTemplate;
